module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264.8 163.8"><path class="st0" fill="#fff" d="M.2 0h264.6v163.6H.2z"/><path class="st3" fill="#e30613" d="M.2 0h264.6v28.6H.2zM.2 135.2h264.6v28.6H.2z"/><path class="st4" fill="#312783" d="M0 56.1h264.8v50.6H0z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/flag/flg4.svg
// module id = 522
// module chunks = 1